import { createMediaQuery } from '@oneaudi/aoa-shared-editorial-components';
import styled from 'styled-components';
import { SYS_SPACE_RELATIVE_XL, SYS_PAGE_MARGIN } from '@oneaudi/unified-web-common';

const SYS_SPACE_RELATIVE_BP_MD_MD = '16px';

const breakpoints = {
  l: '1024',
};

export const Container = styled.div`
  display: flex;
  flex-wrap: wrap;
  padding: ${process.env.IS_LEGACY ? '36px 9px' : `${SYS_SPACE_RELATIVE_XL} 9px`};
  -webkit-font-smoothing: antialiased;

  ${createMediaQuery({
    l: ({ layout }) => {
      if (layout === 'Irregular - 2x1 split column right') {
        return { 'justify-content': 'end' };
      }
    },
  })}

  @media (min-width: ${breakpoints.l}px) {
    padding: ${
      process.env.IS_LEGACY
        ? '54px'
        : SYS_SPACE_RELATIVE_XL + SYS_PAGE_MARGIN + SYS_SPACE_RELATIVE_XL
    };
  }
`;

export const StyledContentTileContainer = styled.div`
  box-sizing: border-box;
  padding: ${process.env.IS_LEGACY ? '6px' : SYS_SPACE_RELATIVE_BP_MD_MD};
  width: 100%;

  @media (min-width: ${breakpoints.l}px) {
    width: ${({ width }) => `${width};`};
  }

  .event-shield {
    height: 100%;
  }

  .edit > div {
    height: 100%;
  }
`;

export const SplitColumnContainer = styled.div`
  width: 100%;
  @media (min-width: ${breakpoints.l}px) {
    width: 50%;
  }
`;
